module.exports = __webpack_public_path__ + "img/digital_product.79645d85.png";